import { StrictMode, type ComponentType, type ReactNode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './app/App'
import { reportError } from './app/reportError'
import { browserRecovery, installChunkRecovery } from './app/staleChunk'

// After a deploy, an open tab's old screen files are gone: reload once to pick up the new build.
installChunkRecovery(window, browserRecovery(reportError))

async function boot() {
  // A production build takes the sign-in path, and the dev bypass is compiled out. The demo build (CPG_DEMO=1) has
  // no sign-in at all: the server answers as the demo visitor.
  const Session: ComponentType<{ children: ReactNode }> = __CPG_DEMO__
    ? (await import('./app/DemoSession')).DemoSession
    : __DEV_BYPASS_AUTH__
      ? (await import('./app/DevSession')).DevSession
      : (await import('./app/KindeSession')).KindeSession
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <Session>
        <App />
      </Session>
    </StrictMode>,
  )
}

void boot()
